import { useTranslation } from "react-i18next";
import { Grid, GridColumn } from "semantic-ui-react";

import { Dropdown } from "components";
import "modules/DMSv3/Capabilities/components/ColumnsFilter/ColumnsFilter.scss";
import { setSelectedDMSIds, useDMSCapabilitiesQuery, useSelectedDMSIds } from "modules/DMSv3/Capabilities/hooks";
import { getDmsName } from "utils/dms";

const SELECT_ALL_VALUE = 0;

export const ColumnsFilter = () => {
  const { t } = useTranslation();

  const { data: capabilities = [] } = useDMSCapabilitiesQuery();
  const { data: selectedDMSIds } = useSelectedDMSIds();

  const options = [
    { key: SELECT_ALL_VALUE, value: SELECT_ALL_VALUE, text: t("v8_select_all", "Select all") },
    ...capabilities.map(({ id }) => ({ key: id, value: id, text: getDmsName(id) }))
  ];

  const handleChange = (dmsIds: number[]) => setSelectedDMSIds(dmsIds.includes(SELECT_ALL_VALUE) ? capabilities.map(({ id }) => id) : dmsIds);

  return (
    <Grid columns="equal" className="ColumnsFilter">
      <GridColumn>
        <Dropdown
          fluid
          multiple
          selection
          search
          clearable
          selectOnBlur={false}
          value={selectedDMSIds || []}
          options={options}
          placeholder={t("v8_select_dms", "Select DMS")}
          onChange={handleChange}
        />
      </GridColumn>
    </Grid>
  );
};
